import ru from './ru.json';

type RuKeys = keyof typeof ru;

export function useT(key: string, params?: Record<string, string | number>): string {
  const template = (ru as Record<string, string>)[key as RuKeys] ?? key;
  if (!params) return template;
  return template.replace(/\{\{(\w+)\}\}/g, (_, name: string) => {
    const val = params[name];
    return val !== undefined ? String(val) : `{{${name}}}`;
  });
}
